@if (disclaimer) {
  <div class="footer-disclaimer-container">
    <p class="c11n-text-sm" [innerHTML]="content"></p>
  </div>
}
